import { ReactNode, useCallback, useMemo, useState } from 'react';

import { ConfirmationModal, ConfirmationModalProps } from './Modal';

import { emptyFn } from 'utils/function';
import { ConfirmationCtx, RequestConfirmationParams } from './confirmation.context';

export function ConfirmationProvider({ children }: { children: ReactNode }) {
  /**
   * We do this so there's no layout shift upon closing
   */
  const [confirmationConfig, setConfirmationConfig] = useState({
    isOpen: false,
  } as RequestConfirmationParams & { isOpen: boolean });

  const closeModal = useCallback(() => {
    setConfirmationConfig((old) => ({
      ...old,
      isOpen: false,
      onConfirm: emptyFn,
    }));
  }, []);

  const cancelConfirmation = useCallback(() => {
    confirmationConfig?.cancel?.();

    closeModal();
  }, [confirmationConfig, closeModal]);

  const requestConfirmation = useCallback(
    (config: RequestConfirmationParams) => {
      setConfirmationConfig({
        ...config,
        isOpen: true,
        onConfirm: async () => {
          await config.onConfirm();
          closeModal();
        },
      });
    },
    [closeModal],
  );

  const data = useMemo(
    () => ({
      requestConfirmation,
    }),
    [requestConfirmation],
  );

  return (
    <ConfirmationCtx.Provider value={data}>
      <ConfirmationModal
        {...((confirmationConfig || {}) as ConfirmationModalProps)}
        cancel={cancelConfirmation}
      />

      {children}
    </ConfirmationCtx.Provider>
  );
}
